import { inject, Pipe, PipeTransform } from '@angular/core';
import { AttachmentService } from '@shared/modules/main/common/attachments/attachment/attachment.service';
import { CommentModel } from '@dta/shared/models-api-loop/comment/comment.model';

@Pipe({
  name: 'inlineImageClickHandlerFn'
})
export class InlineImageClickHandlerFnPipe implements PipeTransform {
  private readonly attachmentService: AttachmentService = inject(AttachmentService);

  transform(comment: CommentModel): (event: MouseEvent) => void {
    return (event: MouseEvent) => {
      if (!comment.hasAttachments()) {
        return;
      }

      const fileId = (event.target as HTMLElement).id;
      const inlineFiles = comment.getInlineAttachments();
      const fileToView = inlineFiles.find(file => {
        return file.id === fileId || file._id === fileId;
      });

      if (fileToView) {
        this.attachmentService.onFileIconClick({
          comment: comment,
          files: inlineFiles,
          file: fileToView
        });
      }
    };
  }
}
